import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as localization } from './localization'
import { reducer as layout } from './layout'
import { reducer as oidc } from 'redux-oidc'
import { reducer as applicationMenu } from './applicationMenu'
import { reducer as dialogs } from './dialogs'
import { reducer as suppliers } from './suppliers'
import { reducer as orders } from './orders'
import { reducer as grapes } from './grapes'
import { reducer as producers } from './producers'
import { reducer as currencies } from './currencies'
import { reducer as wineStyles } from './wineStyles'
import { reducer as wineTypes } from './wineTypes'
import { reducer as classificationByOrigins } from './classificationByOrigins'
import { reducer as classificationByParamses } from './classificationByParamses'
import { reducer as flavourCharacteristicses } from './flavourCharacteristicses'
import { reducer as produceStyles } from './produceStyles'
import { reducer as vineyardStyles } from './vineyardStyles'
import { reducer as storagePlaces } from './storagePlaces'
import { reducer as regions } from './regions'
import { reducer as countries } from './countries'
import { reducer as districts } from './districts'
import { reducer as subdistricts } from './subdistricts'
import { reducer as evaluators } from './evaluators'
import { reducer as wines } from './wines'
import { reducer as orderProcessing } from './orderProcessing'
import { reducer as bottles } from './bottles'
import { reducer as bottlesSimple } from './bottlesSimple'
import { reducer as bottlesFilter } from './bottlesFilter'
import { reducer as staticFilters } from './staticFilters'
import { reducer as backgroundActions } from './backgroundActions'
import { reducer as fileAttachments } from './fileAttachments'
import { reducer as notifications } from './notifications'
import { reducer as dropzone } from './dropzone'
import { reducer as dashboard } from './dashboard'
import { reducer as winesInStock } from './winesInStock'
import { reducer as temporary } from './temporary'

import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

export default combineReducers({
  localization,
  layout,
  dialogs,
  oidc,
  applicationMenu,
  suppliers,
  orders,
  grapes,
  producers,
  currencies,
  wineStyles,
  wineTypes,
  classificationByOrigins,
  classificationByParamses,
  flavourCharacteristicses,
  produceStyles,
  vineyardStyles,
  storagePlaces,
  regions,
  countries,
  districts,
  subdistricts,
  wines,
  orderProcessing,
  bottles,
  bottlesSimple,
  bottlesFilter,
  staticFilters,
  backgroundActions,
  fileAttachments,
  notifications,
  dropzone,
  dashboard,
  winesInStock,
  evaluators,
  temporary,
  router: connectRouter(history)
})
